/* eslint-disable eqeqeq, func-names, max-len, no-new, no-plusplus, no-shadow, no-underscore-dangle */
/* global google:false */
import 'fancybox-core';
import 'fancybox-media';
import 'jquery-placeholder';
import 'jquery-touchswipe';

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(RunAjaxJs);

function RunAjaxJs() {
  HandlePartsList();
}

$(document).ready(() => {
  RunDocumentReadyFunctions();
  WindowLoadFunctions();
});

$(window).load(() => {
  WindowLoadFunctions();
});

$('.slideReviewForm').click(() => {
  $('.reviewSlide').slideToggle();

  return false;
});

$('.closeReview').click(() => {
  $('.reviewSlide').slideUp();

  return false;
});

// Have the Savonet iframe lazy load only when the "Manual & Spare Parts" tab is clicked.
function HandlePartsList() {
  if ($('.js-parts-list.bannerLinkActive').length) {
    const $ttiIframe = $('.manuals.infoDiv iframe');
    if ($ttiIframe.attr('src') === undefined && $ttiIframe.attr('data-src') !== undefined) {
      $ttiIframe.attr('src', $ttiIframe.attr('data-src'));
    }
  }
}

function WindowLoadFunctions() {
  if ($('.categoryBanner').length <= 0) {
    (function () {
      const imgHeight = parseInt($('.blackBanner img').height(), 10);
      const h1Height = parseInt($('.blackBanner').find('h1').outerHeight(), 10);
      if (h1Height > imgHeight) {
        $('.blackBanner').css('height', h1Height);
      } else {
        $('.blackBanner').css('height', imgHeight);
        $('.blackBanner img').css('height', imgHeight);
      }
    }());
  }

  $('.navbar-toggle').click(function () {
    const $menu = $($(this).data('target')).show();

    if ($menu.css('right') == '0px') {
      $menu.animate({
        right: '-100%',
      }, 500, 'swing');
    } else {
      $menu.show();
      $menu.animate({
        right: '0',
      }, 500, 'swing');
    }

    return false;
  });
}

function RunDocumentReadyFunctions() {
  const pathname = window.location;
  if ((pathname.href.indexOf('subscriberguid') > -1 && (pathname.href.indexOf('newsletterguid') > -1))) {
    $('.InfoLabel:first').css('display', 'none');
    $('.UnsubscriptionEmail').css('display', 'none');
    $('.ContentButton').css('display', 'none');
  }

  $('.shareYourStory a').fancybox({
    beforeShow() {
      $('.fancybox-skin').css('backgroundColor', '#000000');
      $('.fancybox-skin').css('padding', '5px');
    },
  });

  $('#ShareYourStory .slide1 .uploadForm').click(() => {
    $('#ShareYourStory .slide1').animate({
      marginLeft: '-840px',
    }, 250);
    return false;
  });

  $('#ShareYourStory .goBack a').click(() => {
    $('#ShareYourStory .slide1').animate({
      marginLeft: '0',
    }, 250);
    return false;
  });

  function imageShow() {
    if ($(window).innerWidth() > 767) {
      $('.prodImagesSec .mobAccord').removeAttr('style');
    }
  }

  function prodViewToggle() {
    $('.infoArea .infoDiv h2').click(function () {
      if ($(window).innerWidth() < 767) {
        const detail = $(this).next('.mobAccord');
        if (detail.css('display') === 'block') {
          detail.slideUp();
        } else {
          detail.slideDown();
        }
      }
    });
  }
  imageShow();
  prodViewToggle();

  $(window).resize(() => {
    imageShow();
    if ($(window).innerWidth() > 767) {
      $('.features.infoDiv .mobAccord').show();
    }
  });

  $('.CalendarTextBox').click(function () {
    $(this).next('.CalendarIcon').trigger('click');
    return false;
  });

  // + nav
  $('.plus').click(() => {
    $('.topNav ul').slideToggle();
  });

  $('.topNav a').each(function () {
    const $this = $(this);
    if ($this.next('ul').length > 0) {
      $this.attr('data-toggle', 'dropdown');
    }
  });

  $('label.hidden, .placeHolders label').each(function () {
    const $label = $(this);
    const fieldId = $label.attr('for');
    if (fieldId.length > 0) {
      const $input = $(`#${fieldId}`);
      $input.attr('placeholder', $label.html());
      $($input).placeholder();
    }
  });

  // Fix inputs with placeholders
  $('input[placeholder], textarea[placeholder]').placeholder();

  // banner links drop
  $('.bannerLinks li').click(function () {
    const $this = $(this);
    const indexItem = $this.index();
    $this.addClass('bannerLinkActive');
    $('.bannerLinks li').removeClass('bannerLinkActive');
    $this.addClass('bannerLinkActive');
    $('.noPadTab .infoDiv').hide();
    $('.noPadTab .infoDiv').eq(indexItem).show();

    HandlePartsList();
    return false;
  });

  $('.accordionItem .accordTop').unbind();
  $('.accordionItem .accordTop').click(function () {
    const $this = $(this);
    const $defaultImage = $('#carousel.photocar img:first');

    if ($this.hasClass('activeAccord') === false) {
      const $toClose = $('.accordionItem .accordDrop').not($this.next('.accordDrop'));
      $toClose.slideUp();
      $toClose.prev('.accordTop').removeClass('activeAccord');
      $this.next('.accordDrop').slideToggle();
      $this.toggleClass('activeAccord');

      if ($this.attr('data-product') !== undefined) {
        const $variantImage = $(`#carousel.photocar img[data-product*='${$this.attr('data-product')}'`);
        if ($variantImage.length) {
          $variantImage.click();
        } else if ($defaultImage.length) {
          $defaultImage.click();
        }
      }
    } else {
      $this.next('.accordDrop').slideToggle();
      $this.toggleClass('activeAccord');
      $defaultImage.click();
    }
  });

  if ($('.locator').length) {
    const input = document.getElementById($('.locator').attr('id'));
    new google.maps.places.Autocomplete(input);
  }

  // Sign up UK page
  $('#terms-conditions').hide();
  $('#view-terms-conditions').click(() => {
    if ($('#terms-conditions').is(':hidden')) {
      $('#terms-conditions').slideDown('slow');
      $('#view-terms-conditions .arrow').addClass('down');
    } else {
      $('#terms-conditions').slideUp('slow');
      $('#view-terms-conditions .arrow').removeClass('down');
    }
    return false;
  });

  let signUpProductHeight = 0;

  $('.sign-up-and-win .products .item').each(function () {
    const thisHeight = $(this).height();

    if (thisHeight > signUpProductHeight) {
      signUpProductHeight = thisHeight;
    }
  });

  $('.sign-up-and-win .products .item').each(function () {
    $(this).height(signUpProductHeight);
  });
}

$('.view-tcs').click(() => {
  $('html, body').animate({
    scrollTop: $('#view-terms-conditions').offset().top,
  }, 1000);
  if ($('#terms-conditions').is(':hidden')) {
    $('#terms-conditions').slideDown('slow');
    $('#view-terms-conditions .arrow').addClass('down');
  } else {
    $('#terms-conditions').slideUp('slow');
    $('#view-terms-conditions .arrow').removeClass('down');
  }
  return false;
});
